import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  ValuesDigital,
} from '@/domain/impact-co2/entities/question.entity';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'DIGITAL';
const SECTORS: Sector[] = ['PUBLIC'];

export function mapToDigitalAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesDigital>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const dataUsage = mapToDataUsage(row);
  const videoViews = mapToVideoViews(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      dataUsage,
      videoViews,
    },
  };
  return answer;
}

function mapToDataUsage(row: ImportedRow): number {
  const tgsValue = row['dataUsage'];
  const result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('dataUsage', tgsValue, row);
  }
  return result;
}

function mapToVideoViews(row: ImportedRow): number {
  const tgsValue = row['videoViews'];
  const result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('videoViews', tgsValue, row);
  }
  return result;
}
